<app-content-category-distribution
  [data]="contentCategoryData"
  [myBrand]="myBrand"
  [myCompetitors]="myCompetitors"
  [brandColorsMap]="brandColorsMap"
  [loading]="loading"
  [showFullListButton]="false"
  [isAdType]="true">
</app-content-category-distribution>
